import React, { useState, useEffect } from "react";
import bannerdefaultImage from '../../assets/icons/message-manager/bannerdefault.png';
import './Banner.css';
import { use } from "react";

const slideInterval = 4000;
const bannerContent = [
    {
        bannerImageUrl: 'https://cmsmktg.screenbeam.com/wp-content/uploads/2021/11/banner1.png',
        bannerHref: 'https://cmsmktg.screenbeam.com/screenbeamad1'
    },
    {
        bannerImageUrl: 'https://cmsmktg.screenbeam.com/wp-content/uploads/2021/11/banner2.png',
        bannerHref: 'https://cmsmktg.screenbeam.com/screenbeamad2'
    },
    {
        bannerImageUrl: 'https://cmsmktg.screenbeam.com/wp-content/uploads/2021/11/banner3.png',
        bannerHref: 'https://cmsmktg.screenbeam.com/screenbeamad3'
    }
];
const defaultBannerContent = [
    {
        bannerImageUrl: bannerdefaultImage,
        bannerHref: 'https://screenbeam.com'
    }
];

const Banner = () => {
    const [content, setContent] = useState([]);
    const [isNetwork, setIsNetwork] = useState(false);
    const [slides, setSlides] = useState([]);

    const checkImageExists = (url) => {
        return new Promise((resolve) => {
            try {
                const img = new Image();
                img.src = url;
                if (img.complete) {
                    resolve(true);
                } else {
                    img.onload = () => resolve(true);
                    img.onerror = () => resolve(false);
                }
            } catch (error) {
                resolve(false);
            }
        });
    };

    const validateBannerUrl = async () => {
        const filterContent = await Promise.all(
            bannerContent.map(async (slide) => {
                const exists = await checkImageExists(slide.bannerImageUrl);
                return exists ? slide : null;
            })
        );
        setContent(filterContent.filter(Boolean));
    };

    const imageOnclick = (e, url) => {
        if (isNetwork) window.open(url, "_blank");
    };

    useEffect(() => {
        if (window.navigator.onLine) {
            setIsNetwork(true);
            validateBannerUrl();
        }else
            setSlides(defaultBannerContent);
        const carouselElement = document.querySelector('#carouselExampleControls');
        if (carouselElement) {
            new window.bootstrap.Carousel(carouselElement, {
                interval: slideInterval,
                ride: 'carousel'
            });
        }
    }, []);

    useEffect(() => {
        setSlides(content.length > 0 ? content : defaultBannerContent);
    }, [content]);

    return (
        <div className="dashboard-banner mb-4">
            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {slides.map((slide, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`} data-bs-interval={slideInterval}>
                            <img
                                src={slide.bannerImageUrl}
                                id={window.navigator.onLine ? "bannerImageSlide" : ""}
                                className="d-block w-100"
                                onClick={(e) => imageOnclick(e, slide.bannerHref)}
                            />
                        </div>
                    ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
};

export default Banner;